import React from 'react';
import Icon from '../../../components/AppIcon';

const FilterPanel = ({ filters, onFilterChange }) => {
  return (
    <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm">
      <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
        <Icon name="SlidersHorizontal" size={20} color="#3b82f6" />
        Filter
      </h3>
      <div className="space-y-6">
        {/* Exceptional Only Toggle */}
        <div className="flex items-center justify-between">
          <label className="text-sm font-medium text-gray-700">
            Exceptional Only
          </label>
          <button
            onClick={() => onFilterChange('exceptionalOnly', !filters?.exceptionalOnly)}
            className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
              filters?.exceptionalOnly ? 'bg-blue-600' : 'bg-gray-300'
            }`}
          >
            <span
              className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                filters?.exceptionalOnly ? 'translate-x-6' : 'translate-x-1'
              }`}
            />
          </button>
        </div>

        {/* Location Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Location
          </label>
          <select
            value={filters?.location}
            onChange={(e) => onFilterChange('location', e?.target?.value)}
            className="w-full bg-white border border-gray-300 rounded-lg px-3 py-2 text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="all">All</option>
            <option value="toronto">Toronto, ON</option>
            <option value="vancouver">Vancouver, BC</option>
            <option value="montreal">Montreal, QC</option>
            <option value="ottawa">Ottawa, ON</option>
            <option value="remote">Remote</option>
          </select>
        </div>

        {/* Industry Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Industry
          </label>
          <select
            value={filters?.industry}
            onChange={(e) => onFilterChange('industry', e?.target?.value)}
            className="w-full bg-white border border-gray-300 rounded-lg px-3 py-2 text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="all">All</option>
            <option value="technology">Technology</option>
            <option value="construction">Construction</option>
            <option value="real-estate">Real Estate</option>
            <option value="finance">Finance</option>
            <option value="healthcare">Healthcare</option>
          </select>
        </div>

        {/* Role Type Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Role Type
          </label>
          <select
            value={filters?.roleType}
            onChange={(e) => onFilterChange('roleType', e?.target?.value)}
            className="w-full bg-white border border-gray-300 rounded-lg px-3 py-2 text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="all">All</option>
            <option value="engineering">Engineering</option>
            <option value="product">Product</option>
            <option value="operations">Operations</option>
            <option value="executive">Executive</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;